import * as types from "./types";
import axiosInstance from "../../Axios/axiosInstance";
import removeToken from "../../Auth/removeToken";
import { SUCCESS_STATUS, UNAUTHORIZED_USER } from "../../Auth/statusCodes.js";
import { urlService } from "../../utils/urlService";
import { removeItem, setItem } from "../../Auth/localStorageService.js";
import { getSessionItem } from "../../Auth/sessionStorageService.js";
import { changeLanguage } from "../LanguageReducer/languageAction";
import { languageKey } from "../../components/LanguageSelector/LanguageSelectorConstant";
import { reverseLangMap } from "../../consts/constant";

export const showUserProfileLoader = (payload) => {
  return {
    type: types.SHOW_USER_PROFILE_LOADER,
    payload,
  };
};

export const errorFetchingUserDetails = (payload) => {
  return {
    type: types.IS_ERROR_FETCHING_USER_DETAILS,
    payload,
  };
};

export const setTab = (payload) => {
  return {
    type: types.SET_TAB,
    payload,
  };
};

export const resetTab = () => {
  urlService.removeParam("accountSection");
  return {
    type: types.RESET_TAB,
  };
};

export const editDetailsHandler = (payload) => {
  return {
    type: types.EDIT_DETAILS_HANDLER,
    payload,
  };
};

export const setCurrentUserData = (payload) => {
  return {
    type: types.CURRENT_USER_DATA,
    payload,
  };
};

export const getUserData = (onSuccess) => {
  return (dispatch, getState) => {
    dispatch(showUserProfileLoader(true));
    axiosInstance
      .get("/user/me")
      .then((res) => {
        if (res.status === SUCCESS_STATUS) {
          dispatch(setCurrentUserData(res.data));
          dispatch(showUserProfileLoader(false));
          dispatch(errorFetchingUserDetails(false));

          const userData = res.data?.data;
          const currentLanguage = getState().languageChange.language;
          if (
            userData?.languagePreferred &&
            !getSessionItem("languageSessionOnly")
          ) {
            const langKey =
              reverseLangMap[userData.languagePreferred] || languageKey.en;
            if (langKey !== currentLanguage) {
              dispatch(changeLanguage(langKey));
            }
            setItem("language", langKey);
          }

          onSuccess?.(userData);
          return;
        }
        removeItem("AUTH");
      })
      .catch((err) => {
        removeItem("AUTH");
        if (err?.response?.status !== UNAUTHORIZED_USER) {
          if (err?.response?.status !== UNAUTHORIZED_USER) {
            removeToken();
          }
        }
        dispatch(showUserProfileLoader(false));
        dispatch(errorFetchingUserDetails(true));
      });
  };
};
